export default __webpack_public_path__ + "static/cc-b591ddddbb91c9e271b49c38b7dbf15f.png";